module.exports = __webpack_public_path__ + "img/sjgl.2252ba0f.png";